import { createColumnHelper } from '@tanstack/react-table';

import { UserInstruction } from '../../types';

import { ActionsCell, ModifiedCell, NameCell, ProductsCell, StatusCell } from './cells';

type CreateColumnsParams = {
  handleEditInstruction: (instruction: UserInstruction) => void;
  handleDeleteInstruction: (instruction: UserInstruction) => void;
  getProductSku: (instruction: UserInstruction) => string[];
};

const createColumns = ({
  handleEditInstruction,
  handleDeleteInstruction,
  getProductSku,
}: CreateColumnsParams) => {
  const columnsHelper = createColumnHelper<UserInstruction>();

  return [
    columnsHelper.accessor('title', {
      id: 'name',
      header: 'Name',
      size: 650,
      cell: info => (
        <NameCell
          instruction={info.row.original}
          onClick={() => handleEditInstruction(info.row.original)}
        />
      ),
    }),
    columnsHelper.accessor('product_sku', {
      id: 'products',
      header: 'Products',
      size: 150,
      cell: info => <ProductsCell products={getProductSku(info.row.original)} />,
    }),
    columnsHelper.accessor('deactivated', {
      id: 'status',
      header: 'Status',
      size: 100,
      cell: info => <StatusCell deactivated={info.row.original.deactivated} />,
    }),
    columnsHelper.accessor('updated_at', {
      id: 'modified',
      header: 'Modified',
      size: 100,
      cell: info => <ModifiedCell modifiedAt={info.row.original.updated_at} />,
    }),
    columnsHelper.display({
      id: 'actions',
      header: 'Actions',
      size: 80,
      cell: info => (
        <ActionsCell
          onEdit={() => handleEditInstruction(info.row.original)}
          onDelete={() => handleDeleteInstruction(info.row.original)}
        />
      ),
    }),
  ];
};
export default createColumns;
